import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import PageNotFound from '@/common/components/views/PageNotFound'
import OrganizationDetailPage from '@/pages/organizations/detail'

export const Route = createFileRoute('/app/organizations/$organizationId')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { organizationId } = Route.useParams()
  const parsedId = parseInt(organizationId, 10)

  if (!Number.isInteger(parsedId) || parsedId <= 0) {
    return <PageNotFound />
  }

  return <OrganizationDetailPage organizationId={parsedId} />
}
